import axios from 'axios';

// API Configuration
export const LS_API_CONFIG = {
  BASE_URL: 'https://api.lemonsqueezy.com/v1',
  STORE_ID: process.env.REACT_APP_LEMON_SQUEEZY_STORE_ID,
  headers: {
    'Authorization': `Bearer ${process.env.REACT_APP_LEMON_SQUEEZY_API_KEY}`,
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }
};

// Create axios instance for Lemon Squeezy
export const lemonClient = axios.create({
  baseURL: LS_API_CONFIG.BASE_URL,
  headers: LS_API_CONFIG.headers
});

// Subscription plan IDs
export const SUBSCRIPTION_TIERS = {
  THREE_MONTH: process.env.REACT_APP_THREE_MONTH_PLAN_ID,
  SIX_MONTH: process.env.REACT_APP_SIX_MONTH_PLAN_ID,
  ANNUAL: process.env.REACT_APP_ANNUAL_PLAN_ID
};

// API endpoints
export const ENDPOINTS = {
  PRODUCTS: '/products',
  VARIANTS: '/variants',
  SUBSCRIPTIONS: '/subscriptions',
  CHECKOUT: '/checkouts'
};